<template>
  <div>
    <div class="container form-signin3">
      <ul class="nav nav-tabs" v-if="userRole == 'SUPER_MASTER' || userRole == 'MANAGER'">
        <li class="nav-item">
          <a class="nav-link" href="#" v-on:click="handleClick('first')" aria-current="page">Customer Ledger</a>
        </li>
        <li class="nav-item">
          <a class="nav-link active">Master Ledger</a>
        </li>
      </ul>
      <div class="row">
        <div class="col-md-12" style="padding-left: 50px; padding-right: 50px">
          <form class="form-inline transparent-form p10 border-page mt-2">
            <div class="col-lg-12 row">
              <div class="col-lg-2 col-sm-3 mt-1">
                <Field type="text" class="form-control" name="ledger_balance" placeholder="Search" v-model="keyword"
                  v-on:keyup="searchList()" />
              </div>
              <div class="col-lg-2 col-sm-3 mt-1" v-if="role == 'SUPER_MASTER' || role == 'MANAGER'">
                <Multiselect mode="single" trackBy="new_name" label="new_name" valueProp="id" class="register-select"
                  placeholder="Master" v-model="master_id" :options="master_list" searchable="true" />
              </div>
              <div class="col-lg-4 text-right">
                <button id="btn-search" type="button" v-on:click="searchList()" class="btn btn-primary mb-2">
                  Search
                </button>
                &nbsp;
                <button type="button" v-on:click="reset" class="btn btn-secondary mb-2">
                  Reset
                </button>
                &nbsp;
              </div>
              <div class="col-4 text-right mt-2" :style="balance < 0
                ? 'color: red !important'
                : 'color: blue !important'
                ">
                NET AMOUNT :
                {{
                  this.balance
                    ? $helperService.getThousandConverter(
                      $helperService.getFormattedPrice(this.balance)
                    )
                    : 0.0
                }}
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="row" style="padding-left: 50px; padding-right: 50px; margin-top: 5px">
        <div class="col-md-6 bg-light border-page text-center">
          <table id="table" style="
              margin-top: 16px;
              width: 500px;
              margin-left: auto;
              margin-right: auto;
            " data-toggle="table" data-search="true" data-filter-control="true" data-toolbar="#toolbar"
            class="table table-sm text-center text-white table-bordered product-list table-hover">
            <thead>
              <tr>
                <th class="head">Sr.No</th>
                <th class="head sorting" id="id-name" v-on:click="sorting('name', 'id-name')">
                  Name
                </th>
                <th class="head sorting" style="width: 185px" id="id-balance"
                  v-on:click="sorting('balance', 'id-balance')">
                  Balance
                </th>
              </tr>
            </thead>
            <tbody v-show="!loader">
              <tr v-for="(data, index) in list" :key="index" style="cursor: pointer">
                <td style="font-size: 13px !important; font-weight: 600" class="body" v-on:click="
                  openWindow('/user-settlement/' + data.name + '/' + data.id)
                  ">
                  {{ getSrNo(index) }}
                </td>

                <td style="
                    text-align: left;
                    font-size: 11px !important;
                    font-weight: 600;
                  " class="body" v-on:click="
                    openWindow(
                      '/master-user-settlement/MASTER/' +
                      data.master.name +
                      '/' +
                      data.master.id
                    )
                    ">
                  {{ data.master ? data.master.name : "" }}
                </td>
                <td style="
                    text-align: right;
                    font-size: 13px !important;
                    font-weight: 600;
                  " class="body" :style="data.balance < 0
                    ? 'color: red !important'
                    : 'color: blue !important'
                    " v-on:click="
                      openWindow('/user-settlement/' + data.name + '/' + data.id)
                      ">
                  {{
                    data.balance
                      ? $helperService.getThousandConverter(
                        $helperService.getFormattedPrice(data.balance)
                      )
                      : 0
                  }}
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td class="body" style="
                    text-align: right;
                    font-size: 13px !important;
                    font-weight: 600;
                  " :style="totalcredit < 0
                    ? 'color: red !important'
                    : 'color: blue !important'
                    ">
                  {{
                    totalcredit
                      ? $helperService.getThousandConverter(
                        $helperService.getFormattedPrice(totalcredit)
                      )
                      : 0
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-6 bg-light border-page text-center">
          <table id="table" style="
              margin-top: 16px;
              width: 500px;
              margin-left: auto;
              margin-right: auto;
            " data-toggle="table" data-search="true" data-filter-control="true" data-toolbar="#toolbar"
            class="table table-sm text-center text-white table-bordered product-list table-hover">
            <thead>
              <tr>
                <th class="head">Sr.No</th>
                <th class="head sorting" id="id-name" v-on:click="sorting('name', 'id-name')">
                  Name
                </th>
                <th class="head sorting" style="width: 185px" id="id-balance"
                  v-on:click="sorting('balance', 'id-balance')">
                  Balance
                </th>
              </tr>
            </thead>
            <tbody v-show="!loader">
              <tr v-for="(data, index) in debitlist" :key="index" style="cursor: pointer">
                <td style="font-size: 13px !important; font-weight: 600" class="body" v-on:click="
                  openWindow('/user-settlement/' + data.name + '/' + data.id)
                  ">
                  {{ getSrNo(index) }}
                </td>

                <td style="
                    text-align: left;
                    font-size: 11px !important;
                    font-weight: 600;
                  " class="body" v-on:click="
                    openWindow(
                      '/master-user-settlement/MASTER/' +
                      data.master.name +
                      '/' +
                      data.master.id
                    )
                    ">
                  {{ data.master ? data.master.name : "" }}
                </td>
                <td style="
                    text-align: right;
                    font-size: 13px !important;
                    font-weight: 600;
                  " class="body" :style="data.balance < 0
                    ? 'color: red !important'
                    : 'color: blue !important'
                    " v-on:click="
                      openWindow('/user-settlement/' + data.name + '/' + data.id)
                      ">
                  {{
                    data.balance
                      ? $helperService.getThousandConverter(
                        $helperService.getFormattedPrice(data.balance)
                      )
                      : 0
                  }}
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td class="body" style="
                    text-align: right;
                    font-size: 13px !important;
                    font-weight: 600;
                  " :style="totaldebit < 0
                    ? 'color: red !important'
                    : 'color: blue !important'
                    ">
                  {{
                    totaldebit
                      ? $helperService.getThousandConverter(
                        $helperService.getFormattedPrice(totaldebit)
                      )
                      : 0
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <ErrorComponent @retry="getList(0)" ref="errorComponent" />
        <div class="row mx-0 mb-4">
          <div class="col-lg-10 mt-1 text-center">
            <div class="page-bottom-pagination text-right">
              <Pagination @page-change="pageChange" @items-per-page-change="itemsPerPageChange" ref="listPagination" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <DeleteModal @remove="deleteRecord($event)" @get-list="getList(0)" ref="deleteItem" />
  </div>
</template>
<script>
import { Field } from "vee-validate";
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import Multiselect from "@vueform/multiselect";
import DeleteModal from "@/components/DeleteModal";
import moment from "moment";
export default {
  components: {
    ErrorComponent,
    Field,
    Multiselect,
    DeleteModal,
    Pagination,
  },
  name: "MasterLedgerReport",
  data() {
    return {
      loader: true,
      role: this.$store.getters.getUser?.role,
      type: "Default",
      list: [],
      debitlist: [],
      master_list: [],
      broker_list: [],
      fromDate: "",
      toDate: "",
      debit: 0,
      balance: 0,
      credit: 0,
      totalcredit: 0,
      totaldebit: 0,
    };
  },
  mounted() {
    this.checkAccess();
    this.getList(0);
    this.getBrokerList();
    this.getMasterList();
  },
  computed: {
    userRole() {
      return this.$store.getters.getUser?.role;
    },
  },
  methods: {
    checkAccess() {
      var access = this.$store.getters.getAccess;
      if (access.is_ledgerReport == 0 && this.role != "ADMIN") {
        this.$router.push("/access-denied");
      }
    },
    getMasterList() {
      this.$api
        .getAPI({
          _action: "/master-list",
        })
        .then((res) => {
          this.master_list = res;
          for (var i in this.master_list) {
            this.master_list[i].new_name =
              this.master_list[i].name + " (" + this.master_list[i].code + ")";
          }
        })
        .catch(() => { });
    },
    getBrokerList() {
      this.$api
        .getAPI({
          _action: "/broker-list",
        })
        .then((res) => {
          this.broker_list = res;
          for (var i in this.broker_list) {
            this.broker_list[i].new_name =
              this.broker_list[i].name + "(" + this.broker_list[i].code + ")";
          }
        })
        .catch(() => { });
    },
    handleClick(activeName) {
      if (activeName == "first") {
        this.$router.push("/ledger-report");
      }
    },
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList() {
      this.$refs.errorComponent.updateFormLoader(true);
      this.list = [];
      this.debitlist = [];
      this.balance = 0;
      this.totalcredit = 0;
      this.totaldebit = 0;
      var searchObj = {};

      if (this.fromDate) {
        searchObj.from_date = moment(this.fromDate).format("yyyy-MM-DD");
      }

      if (this.toDate) {
        searchObj.to_date = moment(this.toDate).format("yyyy-MM-DD");
      }
      if (this.broker_id) {
        searchObj.broker_id = this.broker_id;
      }
      if (this.master_id) {
        searchObj.master_id = this.master_id;
      }

      if (this.type) {
        searchObj.type = this.type;
      }
      if (this.keyword) {
        searchObj.keyword = this.keyword;
      }
      searchObj.role = "USER";
      searchObj.sort_by = "users.name";
      searchObj.order_by = "asc";
      this.$api
        .getAPI({
          _action: "/master-balanced-pagination-list",
          _body: searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.balance = 0;
          for (var i in res.list) {
            res.list[i].name =
              (res.list[i].name
                ? this.$helperService.getUpperCase(res.list[i].name)
                : "") +
              (res.list[i].code
                ? "(" + this.$helperService.getUpperCase(res.list[i].code) + ")"
                : "");
            this.balance += res.list[i].balance ? res.list[i].balance : 0;
          }

          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No Data available");
            this.$refs.errorComponent.updateFormLoader(false);
          }
          this.list = [];
          this.debitlist = [];
          this.totalcredit = 0;
          this.totaldebit = 0;
          for (var k in res.list) {
            if (res.list[k].master) {
              if (res.list[k].balance < 0) {
                this.totaldebit += res.list[k].balance
                  ? res.list[k].balance
                  : 0;
                this.debitlist.push(res.list[k]);
              } else if (res.list[k].balance >= 0) {
                this.totalcredit += res.list[k].balance
                  ? res.list[k].balance
                  : 0;
                this.list.push(res.list[k]);
              }
            }
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateFormLoader(false);
          }
        });
    },
    sorting(sortBy, id, type) {
      this.$refs.errorComponent.updateFormLoader(true);
      this.loader = true;
      if (type) {
        var obj = this.$helperService.sorting(sortBy, id);
        this.getList(1, obj.order_by, obj.sort_by);
      } else {
        var $this = this;
        setTimeout(() => {
          $this.list = $this.$helperService.localSorting(
            $this.list,
            sortBy,
            id
          );
          $this.$refs.errorComponent.updateFormLoader(false);
          $this.loader = false;
        }, 1000);
      }
    },
    searchList() {
      this.getList(0);
      this.getSummaryList();
    },
    reset() {
      this.fromDate = "";
      this.toDate = "";
      this.type = "";
      this.keyword = "";
      this.getList(0);
      this.getSummaryList();
    },
    getDate(date) {
      return date ? moment(date).format("DD/MM/YYYY hh:mm A") : "-";
    },
    getSrNo(index) {
      return this.$refs.listPagination
        ? (this.$refs.listPagination.currentPage - 1) * 20 + (index + 1)
        : index + 1;
    },
    showDeletePopup(data) {
      this.$refs.deleteItem.showModal(
        "Delete Broker",
        "Are you sure you want to delete " + data.name,
        data
      );
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      this.$refs.deleteItem.deleteRecord("/account/" + detail.id);
    },
    openWindow(url) {
      window.open(url, "traget");
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.multiselect {
  background: white !important;
  max-height: 30px !important;
  min-height: 0px !important;
}

.multiselect-tag {
  background: #9cc338 !important;
}

.option-icon {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  margin-right: 10px;
}
</style>
